import { Controller } from '@hotwired/stimulus';

export default class ToastController extends Controller {
  public connect(): void {
    this.element.addEventListener('hidden.bs.toast', () =>
      this.element.remove()
    );
  }
}
